import { Link } from 'wouter';

import { Header } from '~/client/components/Header';
import { Button } from '~/client/components/Primitives';

export function Expired() {
  return (
    <>
      <Header />
      <main className="app-main center">
        <div className="empty-state">
          <h2>that link's expired</h2>
          <p>but you can spin up a new one in about 30 seconds.</p>
          <div className="row" style={{ justifyContent: 'center', marginTop: 24 }}>
            <Link href="/new">
              <Button variant="primary" size="lg">
                Make a fresh poll
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
